import { requestGet, requestPost } from '@/utils/request'

export function getPostList(params){
  return requestGet('/person/post/list', params);
}
export function gePostById(postId){
  return requestGet('/person/post/' + postId);
}
export function savePost(params){
  return requestPost('/person/post', params);
}
export function hasPermiCheck(params){
  return requestPost('/person/post/hasPermiCheck', params);
}
